import { FC, useEffect } from 'react';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import { GeneratedField } from 'src/pages/CompanyPage/_BLL/types';
import { ReferenceDatePicker } from 'src/shared/ui/inputs/ReferenceDatePicker';
import s from './ReferenceDateField.module.scss';

interface Props extends GeneratedField {}

export const ReferenceDateField: FC<Props> = (props) => {
	const {
		namePrefix, //
		propertyName,
		internalName,
	} = props;

	// * Form
	const name = `${namePrefix}${propertyName}.${internalName}`;

	const { setValue, control, trigger, clearErrors } = useFormContext();

	const value = useWatch({ name: `${name}.value` });
	const values = useWatch({ name: `${name}.values` });
	const referenceDate = useWatch({ name: `${name}.referenceDate` });
	const disabled = value === null || values === null;
	const hasValue = !disabled;

	const onChange = (date: string | null) => {
		setValue(`${name}.referenceDate`, date);
		if (date !== null) {
			clearErrors(`${name}.referenceDate`);
		}
	};

	const validate = () => {
		if (hasValue && !referenceDate) {
			return 'reference year required';
		}
	};

	useEffect(() => {
		if (disabled) {
			onChange(null);
		} else {
			trigger();
		}
	}, [disabled]);

	// * Render
	return (
		<Controller
			name={`${name}.referenceDate`}
			control={control}
			rules={{ validate: validate }}
			render={({ field, fieldState }) => (
				<ReferenceDatePicker
					className={s.container}
					value={field.value}
					onChange={onChange}
					disabled={disabled}
					errorMessage={fieldState?.error?.message}
				/>
			)}
		/>
	);
};
